(function() {

    'use strict';

    angular.module('app').
    controller('DriverDetailsModalController', DriverDetailsModalController);

    DriverDetailsModalController.$inject = [
        '$scope',
        'ManifestService', 
        '$uibModalInstance',
        'data',
        'toastr',
        '$http',
        'Request'
        ];

    function DriverDetailsModalController($scope,ManifestService,$uibModalInstance,data,toastr,$http,Request) {

        const vm = this;
        vm.driverDetails = angular.copy(data)
        vm.closeModal = modalClose;
        vm.download = downloadProof;
        vm.driverDetails.createdDate = new Date(vm.driverDetails.createdDate).getTime()
        angular.forEach(vm.driverDetails.truckDriverAuditShipmentDetailSet,function(item){
            vm.driverDetails.truckDriverAuditShipmentDetailSet.manifestNo = item.manifestNo;
            vm.driverDetails.shipmentId = item.shipmentId;
           
        })
        
        function modalClose() {
            $uibModalInstance.dismiss();
        }

        function downloadProof(){
            ManifestService.downloadProofOfSignature(
                res=>{
                    image(res.driverSignature,res.driverSignFile)
                    image(res.shipmentProofUrl,res.shipmentProofFile)
                },
                err=>{
                    console.log(err)
                    toastr.warning('No image uploaded!','Warnning')
                },
                {shipmentId:vm.driverDetails.shipmentId}
            );
        }

        function image(url,filename){
            window.open(url)
            download(url,filename,function(){
                console.log('done')
            })

        }
       
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/manifests/modal/driverDetailsModalController.js